import { render, staticRenderFns } from "./deleteMeal.vue?vue&type=template&id=2f4156c0"
import script from "./deleteMeal.vue?vue&type=script&lang=js"
export * from "./deleteMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports